// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context{
    font-family: Arial, sans-serif;
    margin: 0;
    margin-top: 10%;
    padding: 0;
    height: 100vh;
}

.contextTitle{
    font-size: 25px;
    font-weight: bolder;
}
.aboutImg{
    max-width: 30%;
    margin-top: 60px;
    height: auto;
    margin-bottom: 60px;
}
.titleSeparator {
    max-width: 30%;
    border: none; /* 기본 테두리 제거 */
    height: 2px; /* 선의 두께 */
    background-color: #a7c898; /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
}
.aboutTextBox{
    /*margin-bottom: 200px;*/
}

.aboutText {

    line-height: 1.6; /* 텍스트의 줄 간격 */
    font-size: 16px; /* 텍스트 크기 */
    color: #565b61; /* 텍스트 색상 */
    max-width: 40%; /* 텍스트 박스의 최대 너비 */
    margin: 10px auto; /* 상단 여백, 좌우 자동 여백으로 가운데 정렬 */
    /*padding: 10px 0; !* 상하 여백, 좌우 여백 없음 *!*/
    text-align: start; /* 텍스트를 가운데 정렬 */

}


.space2 {
    display: inline-block; /* 스페이서로 사용 */
    width: 1em; /* 여백 크기 (단어 사이의 간격 조절) */
}

`, "",{"version":3,"sources":["webpack://./src/pages/About/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,yBAAyB,EAAE,UAAU;IACrC,gBAAgB,EAAE,iBAAiB;AACvC;AACA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,gBAAgB,EAAE,cAAc;IAChC,eAAe,EAAE,WAAW;IAC5B,cAAc,EAAE,WAAW;IAC3B,cAAc,EAAE,kBAAkB;IAClC,iBAAiB,EAAE,6BAA6B;IAChD,yCAAyC;IACzC,iBAAiB,EAAE,gBAAgB;;AAEvC;;;AAGA;IACI,qBAAqB,EAAE,aAAa;IACpC,UAAU,EAAE,yBAAyB;AACzC","sourcesContent":[".context{\n    font-family: Arial, sans-serif;\n    margin: 0;\n    margin-top: 10%;\n    padding: 0;\n    height: 100vh;\n}\n\n.contextTitle{\n    font-size: 25px;\n    font-weight: bolder;\n}\n.aboutImg{\n    max-width: 30%;\n    margin-top: 60px;\n    height: auto;\n    margin-bottom: 60px;\n}\n.titleSeparator {\n    max-width: 30%;\n    border: none; /* 기본 테두리 제거 */\n    height: 2px; /* 선의 두께 */\n    background-color: #a7c898; /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n}\n.aboutTextBox{\n    /*margin-bottom: 200px;*/\n}\n\n.aboutText {\n\n    line-height: 1.6; /* 텍스트의 줄 간격 */\n    font-size: 16px; /* 텍스트 크기 */\n    color: #565b61; /* 텍스트 색상 */\n    max-width: 40%; /* 텍스트 박스의 최대 너비 */\n    margin: 10px auto; /* 상단 여백, 좌우 자동 여백으로 가운데 정렬 */\n    /*padding: 10px 0; !* 상하 여백, 좌우 여백 없음 *!*/\n    text-align: start; /* 텍스트를 가운데 정렬 */\n\n}\n\n\n.space2 {\n    display: inline-block; /* 스페이서로 사용 */\n    width: 1em; /* 여백 크기 (단어 사이의 간격 조절) */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
